import React, { Component } from 'react'
import styled from 'styled-components'
import Nav from 'components/Nav'
import { breakPoints } from 'shared/breakPoints'
import Divider from 'svgs/Divider'
import NovoBackground from 'images/NovoBackground.svg'
import NovoPersonnel from 'components/NovoPersonnel'
import ContactForm from 'components/ContactForm'
import Footer from 'components/Footer'
import { ExtraBold, MediumWeightText } from 'shared/textStyles'
import novoGroupImage from 'images/group.jpg'
import driveThru from 'videos/drivethru.mp4'
import takeOrder from 'videos/takeorder.mp4'

class App extends Component {
  state = {
    video: takeOrder,
  }

  driveThruTrigger = React.createRef()
  takeOrderTrigger = React.createRef()
  clearVideoTrigger = React.createRef()

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll = () => {
    if (this.takeOrderTrigger.current !== null) {
      const driveThruTriggerBottom = this.driveThruTrigger.current.getBoundingClientRect()
        .bottom

      const takeOrderTriggerBottom = this.takeOrderTrigger.current.getBoundingClientRect()
        .bottom

      const clearVideoTriggerBottom = this.clearVideoTrigger.current.getBoundingClientRect()
        .bottom

      const switchPoint = window.innerHeight

      if (clearVideoTriggerBottom < switchPoint) {
        this.setState(() => ({ video: '' }))
      } else if (driveThruTriggerBottom < switchPoint) {
        this.setState(() => ({ video: driveThru }))
      } else if (takeOrderTriggerBottom >= 0) {
        this.setState(() => ({ video: takeOrder }))
      }
    }
  }

  handleAtTakeOrder = (entries, observer) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        this.setState({ video: takeOrder })
      }
    })
  }

  handleAtTools = (entries, observer) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        this.setState({ video: driveThru })
      }
    })
  }

  render() {
    const { video } = this.state

    return (
      <React.Fragment>
        <Nav />

        <ParallaxVideo
          key={takeOrder}
          style={{
            visibility: video === takeOrder ? 'initial' : 'hidden',
          }}
          autoPlay
          loop
          muted
          playsInline
        >
          <source src={takeOrder} />
        </ParallaxVideo>

        <ParallaxVideo
          key={driveThru}
          style={{ visibility: video === driveThru ? 'initial' : 'hidden' }}
          autoPlay
          loop
          muted
          playsInline
        >
          <source src={driveThru} />
        </ParallaxVideo>

        <ParallaxVideo
          key="placeholder"
          style={{
            visibility:
              video !== driveThru && video !== takeOrder ? 'initial' : 'hidden',
          }}
          autoPlay
          loop
          muted
          playsInline
        >
          <source src="" />
        </ParallaxVideo>

        <ParallaxWindow>
          <ParallaxContent>
            <div style={{ height: 112, width: 1 }} />a{' '}
            <span style={{ fontFamily: 'Pangram Extra Bold' }}>digital</span>{' '}
            solution for a
            <span style={{ fontFamily: 'Pangram Extra Bold' }}> verbal</span>{' '}
            world
          </ParallaxContent>
        </ParallaxWindow>

        <SectionWithBackground>
          <span style={{ visibilty: 'hidden' }} ref={this.takeOrderTrigger} />

          <SectionText>
            <ExtraBold size="18" style={{ textAlign: 'center' }}>
              Conversational AI for Restaurants
            </ExtraBold>

            <div style={{ height: 16 }} />

            <Divider />

            <div style={{ height: 16 }} />

            <BodyText>
              Novo Labs provides a conversational commerce service for taking
              restaurant orders through high-volume voice channels. We turn
              voice interactions into digital transactions that can be
              personalized and optimized using our artificial intelligence
              platform.
            </BodyText>

            <BodyText>
              Our service has handled over a million fully-automated, live voice
              interactions for more than a thousand restaurants locations.
            </BodyText>

            <BodyText>
              High-volume voice ordering channels, such as phone or drive-thru,
              require much more than just a chatbot. Our service handles the
              real-world conditions of how customers actually talk when they
              order through those existing voice channels.
            </BodyText>

            <BodyText>
              We specifically built our service to scale with the needs of large
              restaurant chains.
            </BodyText>

            <ul
              style={{
                color: 'var(--novo-dark-gray)',
                fontFamily: 'Pangram Regular',
              }}
            >
              <li>
                highly accurate and specialized natural language processing
                stack
              </li>
              <li>deeply developed and trained application</li>
              <li>native menu and point-of-sale integration</li>
              <li>scalable enterprise-grade infrastructure</li>
              <li>connects users to a human when appropriate</li>
              <li>deployable in a few weeks, not many months</li>
            </ul>

            <BodyText>
              To experience a live demonstration of our restaurant ordering
              service, please{' '}
              <span>
                <a style={{ display: 'inline' }} href="#contactForm">
                  contact us
                </a>{' '}
              </span>
              below.
            </BodyText>

            <div style={{ height: 24 }} />

            <Divider />
          </SectionText>

          <ExtraBold>The market will be hearing more from us soon</ExtraBold>

          <div style={{ height: 16 }} />

          <span style={{ visibilty: 'hidden' }} ref={this.driveThruTrigger} />
        </SectionWithBackground>

        <ParallaxWindow />

        <SectionWithBackground>
          <SectionText id="team">
            <ExtraBold size="18" alignment="left" margin="21px 0 0 0">
              We are practical and experienced,
            </ExtraBold>

            <ExtraBold
              color="novo-dark-gray"
              alignment="left"
              margin="2px 0 21px 0"
            >
              and our solutions create valuable, identifiable business outcomes.
              We are a new company built around a strong team, with particular
              experience with e-commerce and digital technologies.
            </ExtraBold>

            <img
              src={novoGroupImage}
              alt="novo employees"
              style={{
                borderRadius: 5,
                display: 'block',
                margin: '0 auto',
                marginBottom: 30,
                maxWidth: 600,
                width: '100%',
              }}
            />
          </SectionText>

          <SectionResponsiveContainer>
            <NovoPersonnel />
          </SectionResponsiveContainer>
        </SectionWithBackground>

        <span style={{ visibility: 'hidden' }} ref={this.clearVideoTrigger} />

        <ContactSection>
          <ContactResponsiveContainer>
            <ExtraBold size="18" alignment="left" margin="0" color="white">
              Let's connect
            </ExtraBold>

            <MediumWeightText margin="0 0 16px 0" color="white">
              Interested in working together? Want to learn more about Novo and
              our solutions? Fill out the contact form below and we’ll get in
              touch.
            </MediumWeightText>

            <ContactForm />
          </ContactResponsiveContainer>
        </ContactSection>

        <Footer />
      </React.Fragment>
    )
  }
}

const ParallaxVideo = styled.video.withConfig({ displayName: 'ParallaxVideo' })`
  width: 100vw;
  min-height: 100vh;
  object-fit: cover;
  overflow: hidden;
  position: fixed;
  top: 0;
  right: 0px;
  z-index: -99;
`

const ParallaxWindow = styled.div.withConfig({ displayName: 'ParallaxWindow' })`
  background-color: rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  height: 550px;

  @media ${breakPoints.ipad} {
    height: 650px;
  }

  @media ${breakPoints.desktop} {
    height: 25%;
  }
`

const SectionText = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  line-height: 1.75;
  padding: 24px 16px;

  @media ${breakPoints.ipad} {
    width: 70%;
    margin: auto;
  }

  @media ${breakPoints.desktop} {
    margin: auto;
    max-width: 750px;
    width: 70%;
  }
`

const SectionResponsiveContainer = styled.div`
  padding: 24px 16px;

  @media ${breakPoints.ipad} {
    width: 70%;
    margin: auto;
  }

  @media ${breakPoints.desktop} {
    width: 70%;
    margin: auto;
  }
`

const ContactResponsiveContainer = styled.div`
  padding: 24px 16px;

  @media ${breakPoints.ipad} {
    width: 70%;
    margin: auto;
  }

  @media ${breakPoints.desktop} {
    margin: auto;
    max-width: 750px;
    width: 70%;
  }
`

const SectionWithBackground = styled.div`
  background-color: white;
  background-image: url(${NovoBackground});
  background-repeat: repeat;
  display: flex;
  flex-direction: column;
  min-height: 80vh;
`

// BodyText is novo-dark-gray in Pangram Regular
const BodyText = styled.p`
  color: var(--novo-dark-gray);
  font-family: 'Pangram Regular';
  text-align: justify;
`

const ParallaxContent = styled.div`
  color: #fff;
  padding: 20px;

  @media ${breakPoints.ipad} {
    font-size: 20px;
  }

  @media ${breakPoints.desktop} {
    font-size: 28px;
  }
`

const ContactSection = styled.div`
  background: #b4b4b0;
  padding: 20px 16px 20px 16px;
`

export default App



// WEBPACK FOOTER //
// ./src/App.js